<template>
  <section class="flex flex-col w-full bg-blue-200">
    <section class="gridClass">
      <div
        class="w-full pt-12 mb-10 flex flex-col laptop:flex-row items-start justify-between"
      >
        <div
          class="w-full flex laptop:w-[350px] text-justify laptop:mt-[50px] flex-col items-baseline justify-center relative"
        >
          <div class="font-bold text-xl z-10 me-6">
            به کسب و کار
            <div class="inline-block relative">
              <div
                class="absolute -left-1 -top-2 rounded-full w-[90%] aspect-square bg-yellow-500"
              ></div>
              <span class="relative">بهتری</span>
            </div>
            <span class="relative"> تبدیل شوید.</span>
          </div>
          <NuxtLink to="https://navatel.ir/blog/" class="z-10 mt-2 mb-6 text-blue-600 fill-blue-600 text-xs font-bold flex align-center text-start">
              مشاهده مطالب وبلاگ
              <IconArrowLeft class="fill-light-blue mx-1 w-4" />
          </NuxtLink>
        </div>
        <div
          v-if="isDesktop"
          class="just-desktop w-full flex-grow laptop:flex laptop:justify-between ps-6"
        >
          <div
            class="flex flex-col justify-start gap-x-4 mb-4 max-w-[150px] whitespace-nowrap"
            v-for="group in Object.values(listMenu).filter((el) => el.list)"
            :key="group.id"
            :class="{
              'order-10 laptop:order-none': group.id == 4,
              'border-r-2 pr-4 border-blue-700': group.id == 1,
            }"
          >
            <span class="mb-3 font-bold">{{ group.title }}</span>
            <div class="flex flex-col items-start gap-y-4">
              <div
                v-for="item in group.list"
                :key="item.id"
                class="font-semibold text-sm"
              >
                <NuxtLink :to="item.url">
                  {{ item.title }}
                </NuxtLink>
              </div>
            </div>
          </div>
          <div>
            <div class="grid grid-cols-2 gap-3">
              <NuxtLink
                class="w-16 bg-white rounded-md shadow flex justify-center align-center p-1"
                to="https://logo.samandehi.ir/Verify.aspx?id=272681&p=uiwkjyoeuiwkgvkamcsirfth"
                aria-label="logo.samandehi.ir"
                no-rel
              >
                <NuxtImg
                  sizes="xs:100vw, sm:100vw, md:100vw, lg:100vw, xl:100vw, xxl:100vw, '2xl':100vw"
                  width="1000"
                  height="1000"
                  format="webp"
                  class="w-full"
                  src="/img/samandehi.webp"
                  alt="ساماندهی"
                />
              </NuxtLink>
              <NuxtLink
                class="w-16 bg-white rounded-md shadow flex justify-center align-center p-1"
                to="https://trustseal.enamad.ir/?id=316143&Code=GZS45wVZZYKd4Se99ieH"
                aria-label="trustseal.enamad.ir"
                no-rel
              >
                <NuxtImg
                  sizes="xs:100vw, sm:100vw, md:100vw, lg:100vw, xl:100vw, xxl:100vw, '2xl':100vw"
                  width="1000"
                  height="1000"
                  format="webp"
                  class="w-full"
                  src="/img/enamad.webp"
                  alt="اینماد"
                />
              </NuxtLink>
              <NuxtLink
                class="w-16 bg-white rounded-md shadow flex justify-center align-center p-1"
                to="https://195.cra.ir/"
                aria-label="195.cra.ir"
                no-rel
              >
                <NuxtImg
                  sizes="xs:100vw, sm:100vw, md:100vw, lg:100vw, xl:100vw, xxl:100vw, '2xl':100vw"
                  width="1000"
                  height="1000"
                  format="webp"
                  class="w-full"
                  src="/img/samane.webp"
                  alt="ویپ"
                />
              </NuxtLink>
              <NuxtLink
                class="w-16 bg-white rounded-md shadow flex justify-center align-center p-1"
                to="https://tehran.irannsr.org/fa/page/104366-%D9%85%D8%B4%D8%A7%D9%87%D8%AF%D9%87-%D8%A7%D8%B9%D8%B6%D8%A7.html?ctp_id=1086&id=33940"
                aria-label="tehran.irannsr.org"
                no-rel
              >
                <NuxtImg
                  sizes="xs:100vw, sm:100vw, md:100vw, lg:100vw, xl:100vw, xxl:100vw, '2xl':100vw"
                  width="1000"
                  height="1000"
                  format="webp"
                  class="w-full"
                  src="/img/nezam.webp"
                  alt="سازمان نظام صنفی"
                />
              </NuxtLink>
            </div>
          </div>
        </div>

        <div v-else class="just-mobile w-full">
          <div class="flex justify-between [&>*]:w-[48%]">
            <div>
              <div class="flex flex-col justify-start gap-x-4 mb-4">
                <span class="mb-3 font-bold text-lg">{{
                  listMenu.menu1.title
                }}</span>
                <div class="flex flex-col items-start gap-y-4">
                  <div
                    v-for="item in listMenu.menu1.list"
                    :key="item.id"
                    class="font-semibold text-sm"
                  >
                    <NuxtLink :to="item.url">
                      {{ item.title }}
                    </NuxtLink>
                  </div>
                </div>
              </div>
              <div class="flex flex-col justify-start gap-x-4 mb-4">
                <span class="mb-3 font-bold text-lg">{{
                  listMenu.menu5.title
                }}</span>
                <div class="flex flex-col items-start gap-y-4">
                  <div
                    v-for="item in listMenu.menu5.list"
                    :key="item.id"
                    class="font-semibold text-sm"
                  >
                    <NuxtLink :to="item.url">
                      {{ item.title }}
                    </NuxtLink>
                  </div>
                </div>
              </div>
            </div>

            <div>
              <div class="flex flex-col justify-start gap-x-4 mb-4">
                <span class="mb-3 font-bold text-lg">{{
                  listMenu.menu2.title
                }}</span>
                <div class="flex flex-col items-start gap-y-4">
                  <div
                    v-for="item in listMenu.menu2.list"
                    :key="item.id"
                    class="font-semibold text-sm"
                  >
                    <NuxtLink :to="item.url">
                      {{ item.title }}
                    </NuxtLink>
                  </div>
                </div>
              </div>
              <div class="flex flex-col justify-start gap-x-4 mb-4">
                <span class="mb-3 font-bold text-lg">{{
                  listMenu.menu4.title
                }}</span>
                <div class="flex flex-col items-start gap-y-4">
                  <div
                    v-for="item in listMenu.menu4.list"
                    :key="item.id"
                    class="font-semibold text-sm"
                  >
                    <NuxtLink :to="item.url">
                      {{ item.title }}
                    </NuxtLink>
                  </div>
                </div>
              </div>
              <div class="flex flex-col justify-start gap-x-4 mb-4">
                <span class="mb-3 font-bold text-lg">{{
                  listMenu.menu7.title
                }}</span>
                <div class="flex flex-col items-start gap-y-4">
                  <div
                    v-for="item in listMenu.menu7.list"
                    :key="item.id"
                    class="font-semibold text-sm"
                  >
                    <NuxtLink :to="item.url">
                      {{ item.title }}
                    </NuxtLink>
                  </div>
                </div>
              </div>

              <div class="w-fit grid grid-cols-2 gap-3">
                <NuxtLink
                  class="w-full bg-white rounded-md shadow flex justify-center align-center p-1"
                  to="https://logo.samandehi.ir/Verify.aspx?id=272681&p=uiwkjyoeuiwkgvkamcsirfth"
                  aria-label="logo.samandehi.ir"
                  no-rel
                >
                  <NuxtImg
                    sizes="xs:100vw, sm:100vw, md:100vw, lg:100vw, xl:100vw, xxl:100vw, '2xl':100vw"
                    width="1000"
                    height="1000"
                    format="webp"
                    class="w-full"
                    src="/img/samandehi.webp"
                    alt="ساماندهی"
                  />
                </NuxtLink>
                <NuxtLink
                  class="w-full bg-white rounded-md shadow flex justify-center align-center p-1"
                  to="https://trustseal.enamad.ir/?id=316143&Code=GZS45wVZZYKd4Se99ieH"
                  aria-label="trustseal.enamad.ir"
                  no-rel
                >
                  <NuxtImg
                    sizes="xs:100vw, sm:100vw, md:100vw, lg:100vw, xl:100vw, xxl:100vw, '2xl':100vw"
                    width="1000"
                    height="1000"
                    format="webp"
                    class="w-full"
                    src="/img/enamad.webp"
                    alt="اینماد"
                  />
                </NuxtLink>
                <NuxtLink
                  class="w-full bg-white rounded-md shadow flex justify-center align-center p-1"
                  to="https://195.cra.ir/"
                  aria-label="195.cra.ir"
                  no-rel
                >
                  <NuxtImg
                    sizes="xs:100vw, sm:100vw, md:100vw, lg:100vw, xl:100vw, xxl:100vw, '2xl':100vw"
                    width="1000"
                    height="1000"
                    format="webp"
                    class="w-full"
                    src="/img/samane.webp"
                    alt="ویپ"
                  />
                </NuxtLink>
                <NuxtLink
                  class="w-full bg-white rounded-md shadow flex justify-center align-center p-1"
                  to="https://tehran.irannsr.org/fa/page/104366-%D9%85%D8%B4%D8%A7%D9%87%D8%AF%D9%87-%D8%A7%D8%B9%D8%B6%D8%A7.html?ctp_id=1086&id=33940"
                  aria-label="tehran.irannsr.org"
                  no-rel
                >
                  <NuxtImg
                    sizes="xs:100vw, sm:100vw, md:100vw, lg:100vw, xl:100vw, xxl:100vw, '2xl':100vw"
                    width="1000"
                    height="1000"
                    format="webp"
                    class="w-full"
                    src="/img/nezam.webp"
                    alt="سازمان نظام صنفی"
                  />
                </NuxtLink>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <div class="gridClass">
      <div class="flex items-center justify-center w-full">
        <div class="flex-grow bg-blue-700 h-0.5 opacity-30" />
        <div class="flex items-center justify-around">
          <NuxtLink
            to="https://www.aparat.com/Navatel"
            aria-label="Navatel Aparat"
          >
            <span
              class="rounded-full w-6 aspect-square cursor-pointer ms-2 flex items-center justify-center overflow-hidden bg-blue-700 hover:bg-blue-500"
            >
              <IconAparat class="w-3/5" />
            </span>
            <span class="sr-only">Navatel Aparat</span>
          </NuxtLink>
          <NuxtLink
            to="https://www.instagram.com/navatel.ir/"
            aria-label="Navatel Instagram"
          >
            <span
              class="rounded-full w-6 aspect-square cursor-pointer ms-2 flex items-center justify-center overflow-hidden bg-blue-700 hover:bg-blue-500"
            >
              <IconInstagram class="w-3/5" />
            </span>
            <span class="sr-only">Navatel Instagram</span>
          </NuxtLink>
          <NuxtLink
            to="https://www.linkedin.com/company/mynavatel/"
            aria-label="Navatel Linkedin"
          >
            <span
              class="rounded-full w-6 aspect-square cursor-pointer ms-2 flex items-center justify-center overflow-hidden bg-blue-700 hover:bg-blue-500"
            >
              <IconLinkedin class="w-3/5" />
            </span>
            <span class="sr-only">Navatel Linkedin</span>
          </NuxtLink>
        </div>
      </div>
    </div>
    <div class="gridClass">
      <div
        class="w-full text-xs font-bold flex items-center justify-start mt-2 mb-4"
      >
        <p>
          تمام حقوق مادی و معنوی متعلق به نواتل، تنها سرویس یکپارچه ابری (UCaaS)
          در ایران می باشد.
        </p>
      </div>
    </div>
    <div class="flex-grow h-2 bg-blue-700" />
  </section>
</template>

<script setup>
const { isDesktop } = useScreen();

const listMenu = {
  menu1: {
    id: "1",
    title: "محصولات",
    isShow: false,
    img: "/img/menu.webp",
    list: [
      {
        id: "1",
        title: "مرکز تلفن ابری",
        icon: "84",
        click: "",
        url: "/products/cloud-pbx/",
      },
      {
        id: "2",
        title: "مرکز تماس ابری",
        icon: "75",
        click: "",
        url: "/products/cloud-callcenter/",
      },
      {
        id: "3",
        title: "تلفن اینترنتی",
        icon: "83",
        click: "",
        url: "/products/internet-phone/",
      },
      {
        id: "7",
        title: "مدیریت ارتباط با مشتری",
        icon: "117",
        click: "",
        url: "/products/crm/",
      },
      {
        id: "9",
        title: "پنل پیامکی",
        icon: "15",
        click: "",
        url: "/products/sms/",
      },
      {
        id: "5",
        title: "فکس‌ ابری",
        icon: "117",
        click: "",
        url: "/products/fax/",
      },
      {
        id: "4",
        title: "چت آنلاین",
        icon: "82",
        click: "",
        url: "/products/webchat/",
      },
      {
        id: "6",
        title: "اپلیکیشن اختصاصی",
        icon: "16",
        click: "",
        url: "/products/dedicated-application/",
      },
      {
        id: "8",
        title: "شماره‌های ابری مخابرات استان تهران",
        // icon: "117",
        click: "",
        url: "/rond/",
      },
    ],
  },
  menu2: {
    id: "2",
    title: "امکانات",
    isShow: false,

    img: "",
    list: [
      {
        id: "1",
        title: "پنل مدیریتی",
        icon: "89",
        click: "",
        url: "/products/management-dashboard/",
      },
      {
        id: "2",
        title: "دفتر کار مجازی",
        icon: "74",
        click: "",
        url: "/products/virtual-office/",
      },
      {
        id: "3",
        title: "تلفن گویا",
        icon: "02",
        click: "",
        url: "/products/smart-ivr/",
      },
      {
        id: "4",
        title: "اتصال به CRM",
        icon: "72",
        click: "",
        url: "/connecting-with-crm/",
      },
      // {
      //   id: "5",
      //   title: "مرکز تماس",
      //   icon: "75",
      //   click: "",
      //   url: "/products/cloud-callcenter/",
      // },
    ],
  },
  menu3: { id: "3", title: "تعرفه ها", url: "/prices/" },
  menu4: {
    id: "4",
    title: "منابع",
    isShow: false,

    img: "",

    list: [
      {
        id: "1",
        title: "آموزش",
        icon: "76",
        url: "/",
        click: "",
      },

      {
        id: "4",
        title: "کاتالوگ",
        icon: "78",
        click: "",
        url: "https://navatel.ir/uploads/Navatel%20Catalogue%201401.pdf",
      },
    ],
  },
  menu7: {
    id: "4",
    title: "شرکای تجاری",
    isShow: false,
    img: "",
    list: [
      {
        id: "1",
        title: "متاما",
        icon: "mokhaberat",
        url: "/metama/",
        click: "",
      },
    ],
  },
  menu5: {
    id: "5",
    title: "ارتباط با ما",
    isShow: false,

    img: "",
    list: [
      {
        id: "1",
        title: "درباره ما",
        icon: "21",
        click: "",
        url: "/about-us/",
      },
      {
        id: "2",
        title: "تماس با ما",
        icon: "105",
        click: "",
        url: "/contact-us/",
      },
      {
        id: "4",
        title: "مدیر عامل و معاونین",
        click: "",
        url: "/managers/",
      },
      {
        id: "3",
        title: "فرصت های شغلی",
        icon: "100",
        click: "",
        url: "/",
      },
    ],
  },
};
</script>

<style scoped>
.last {
  order: 10;
}
.card-items a {
  color: #001d7e;
  font-weight: 400;
  font-size: 16px;
  cursor: pointer;
}

.logo-items {
  width: fit-content;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;
}

.logo-footer {
  width: 45px;
  background-color: #ffffff;
  border-radius: 10px;
  box-shadow: rgba(0, 0, 0, 35%) 0px 2px 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  /* margin: 10px; */
  padding: 6px;
}

.bottom-footer {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}

@media (min-width: 1024px) {
  .cr {
    font-size: 14px;
  }

  .logo-footer {
    width: 66px;
  }

  .container-footer {
    flex-direction: row;
  }

  .card-footer_right {
    padding: 0 0 0 24px;
    max-width: 250px;
    text-align: justify;
  }

  .card-footer_left {
    padding: 0 24px;
  }

  .logo-items {
    padding: 0 24px 0 0;
  }
}

@media (min-width: 1280px) {
  .card-footer_right {
    max-width: 300px;
  }
}
</style>
